import React, { useEffect } from 'react';
import { TabContent, TabPane } from 'reactstrap';
import Client1Form from './Client1Form';
import Client2Form from './Client2Form';
import Dependents from './Dependents';
import AssetsPropertyForm from './AssetsPropertyForm';
import AssetsNonProperty from './AssetsNonProperty';
import Liabilities from './Liabilities';
import AssetsVehicles from './AssetsVehicles';
import Expenses from './Expenses';
import { useGetRequestQuery } from '../../../../../../Hooks/useGetRequestQuery';
import { getClientFactFindDLLService } from '../../../../../../Services/PublicPageServices';
export default function BusinessTabContent({ steps, activeCallBack }: any) {
    const [clientFactsFindData, setClientFactFindData] = React.useState<any>(null);
    const [client1formData , setClient1formData] = React.useState<any>(null)
    const [clientId , setClientId] = React.useState<any>(0)

    const {
        data: clientFactFindData,
        refetch: refetchClientFactFindData,
        isLoading: clientFactFindDataLoading,
        isError: clientFactFindDataIsError,
    } = useGetRequestQuery<any>(
        ['getClientFactFindDLL'],
        getClientFactFindDLLService,
        {
            enabled: true, 
        }
    );
    useEffect(() => {
        if (clientFactFindData?.data && !clientFactFindDataIsError && !clientFactFindDataLoading) { 
            setClientFactFindData(clientFactFindData?.data);
        }
    }, [clientFactFindData]);
    useEffect(() => {
        const script1 = document.createElement('script');
        script1.src = 'https://widgets.leadconnectorhq.com/loader.js';
        script1.setAttribute('data-resources-url', 'https://widgets.leadconnectorhq.com/chat-widget/loader.js');
        script1.setAttribute('data-widget-id', '6755fe767dc877e62db6a6c8');
        document.body.appendChild(script1);

        const script2 = document.createElement('script');
        script2.src = 'https://widgets.leadconnectorhq.com/loader.js';
        script2.setAttribute('data-resources-url', 'https://widgets.leadconnectorhq.com/chat-widget/loader.js');
        document.body.appendChild(script2);

        return () => {
            document.body.removeChild(script1);
            document.body.removeChild(script2);
        };
    }, []);
    return (
        <TabContent className="dark-field" activeTab={steps}>
            <TabPane tabId={1}>
                <Client1Form activeCallBack={activeCallBack} clientFactFindData={clientFactsFindData} clientId={clientId} setClientId={setClientId} setClient1formData={setClient1formData}/>
            </TabPane>
            <TabPane tabId={2}>
                <Client2Form activeCallBack={activeCallBack} clientFactFindData={clientFactsFindData} clientId={clientId} setClientId={setClientId} client1formData={client1formData} />
            </TabPane>
            <TabPane tabId={3}>
                <Dependents activeCallBack={activeCallBack} clientFactFindData={clientFactsFindData}  clientId={clientId} setClientId={setClientId} client1formData={client1formData} />
            </TabPane>
            <TabPane tabId={4}>
                <AssetsPropertyForm activeCallBack={activeCallBack} clientFactFindData={clientFactsFindData}  clientId={clientId} setClientId={setClientId} />
            </TabPane>
            <TabPane tabId={5}>
                <AssetsNonProperty activeCallBack={activeCallBack}   clientId={clientId} setClientId={setClientId} />
            </TabPane>
            <TabPane tabId={6}>
                <AssetsVehicles activeCallBack={activeCallBack} clientFactFindData={clientFactsFindData}  clientId={clientId} setClientId={setClientId} />
            </TabPane>
            <TabPane tabId={7}>
                <Liabilities activeCallBack={activeCallBack} clientFactFindData={clientFactsFindData}  clientId={clientId} setClientId={setClientId} />
            </TabPane>
            <TabPane tabId={8}>
                <Expenses activeCallBack={activeCallBack} clientFactFindData={clientFactsFindData}  clientId={clientId} setClientId={setClientId} />
            </TabPane>
        
        </TabContent>
    );
}
